// src/pages/TermsAndConditions.jsx
import React from "react";

const TermsAndConditions = () => (
  <div className="max-w-4xl mx-auto p-6 font-sans">
    <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">Terms & Conditions</h1>
    
    <div className="space-y-6">
      <p className="text-gray-700 leading-relaxed">
        By using <strong>JR Home Foods</strong>, you agree to the following terms and conditions:
      </p>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">1. Service Overview</h2>
        <p className="text-gray-700">
          JR Home Foods offers home-cooked meal delivery services through daily, weekly, or monthly subscription plans. 
          By subscribing, you agree to receive meals as per the selected plan and delivery schedule.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">2. User Responsibilities</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>You must provide accurate delivery address and contact details.</li>
          <li>Ensure availability at the delivery location during selected time slots.</li>
          <li>Notify us in advance for changes or pauses in delivery (where applicable).</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">3. Subscription Plans</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Plan prices and offerings are subject to change with prior notice.</li>
          <li>Subscriptions are billed in advance.</li>
          <li>Plans are non-transferable and meant for personal use only.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">4. Payment Terms</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>All payments are processed securely through our trusted payment gateway.</li>
          <li>We accept UPI, credit/debit cards, net banking, and wallets.</li>
          <li>Payment details are encrypted and handled securely.</li>
          <li>We do not store sensitive payment information on our servers.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">5. Cancellation & Refund Policy</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Cancellations must be requested via the "My Plans" or "Contact Us" page before the next billing cycle.</li>
          <li>Partial or pro-rata refunds are issued only in exceptional cases at our discretion.</li>
          <li>Refunds (if approved) will be processed via the original payment method within 5–7 working days.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">6. Delivery Policy</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Deliveries are made as per selected slots (e.g., morning/Evening).</li>
          <li>Missed deliveries due to user unavailability are not refundable.</li>
          <li>JR Home Foods reserves the right to cancel or reschedule deliveries in case of emergencies or holidays (with notice).</li>
          <li>Every week Monday will be Holiday (Service not available)</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">7. Changes to Terms</h2>
        <p className="text-gray-700">
          We may update these Terms & Conditions at any time. Continued use of the service implies acceptance of the updated terms.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">8. Contact Information</h2>
        <p className="text-gray-700 mb-3">For any questions or clarifications:</p>
        <div className="bg-green-50 p-4 rounded-lg">
          <p className="font-semibold text-green-800 mb-2">JR Home Foods</p>
          <p className="text-gray-700">📧 Email: help.jrhomefoods@gmail.com</p>
        </div>
      </div>
    </div>
  </div>
);

export default TermsAndConditions;
